package com.example.socialmediaapp.network

import kotlinx.serialization.Serializable

@Serializable
data class LikeResponse(val likeCount: Int = 0, val liked: Boolean = false)

class PostRepository(private val api: ApiClient) {

    // Server toggles like/unlike on POST — call for both states
    suspend fun likePost(postId: String): Result<LikeResponse> = runCatching {
        api.post<LikeResponse>("/api/posts/$postId/like")
    }

    suspend fun unlikePost(postId: String): Result<LikeResponse> = runCatching {
        api.post<LikeResponse>("/api/posts/$postId/like")
    }
}
